import * as React from 'react'
import EnumCombobox, { EnumComboboxProps } from './EnumCombobox'
import { CheckboxOnChangeData } from '@fluentui/react-checkbox'
import { OptionOnSelectData, SelectionEvents } from '@fluentui/react-combobox'

export type BooleanComboboxProps = Omit<
    EnumComboboxProps<'mixed' | boolean>,
    'entities' | 'multiselect' | 'labelKeyPrefix'
> & {
    onOptionSelect: (event: SelectionEvents, data: CheckboxOnChangeData) => void
}

/**
 * An EnumCombobox returning either true, false or 'mixed' when 'Beide' has been selected.
 */
export default function BooleanCombobox(props: BooleanComboboxProps) {
    return (
        <EnumCombobox<'mixed' | boolean>
            required
            entities={['mixed', true, false]}
            labelKeyPrefix={'base.toggle.boolean'}
            {...props}
            onOptionSelect={(event: SelectionEvents, data: OptionOnSelectData) => {
                let parsedOption = data.selectedOptions?.[0]
                parsedOption = parsedOption === 'mixed' ? parsedOption : JSON.parse(data.selectedOptions?.[0])

                return props.onOptionSelect(event, {
                    checked: (typeof parsedOption === 'boolean' ? parsedOption : 'mixed') as 'mixed' | boolean,
                })
            }}
        />
    )
}
